import { WIDGET_KIND_META, type WidgetKind } from "../widgetKind";
import type { GroupId, WorkspaceWidget } from "./workspace.types";

/**
 * Whether a widget kind participates in symbol groups. Portfolio History and
 * Balances are account-wide, so a workspace group never claims them.
 */
export const isGroupEligibleKind = (kind: WidgetKind): boolean =>
  WIDGET_KIND_META[kind].isSingleSymbol;

export const getGroupEligibleWidgetIds = (
  widgets: Record<string, WorkspaceWidget>,
): string[] =>
  Object.values(widgets)
    .filter((widget) => isGroupEligibleKind(widget.kind))
    .map((widget) => widget.id);

/**
 * The workspace-wide group: the one group every eligible widget shares.
 * Any disagreement — including a mix of assigned and unassigned — reads as no
 * workspace group.
 */
export const resolveWorkspaceGroupId = (
  widgets: Record<string, WorkspaceWidget>,
): GroupId | null => {
  const eligible = Object.values(widgets).filter((widget) =>
    isGroupEligibleKind(widget.kind),
  );
  const first = eligible[0];
  if (!first || first.groupId === null) {
    return null;
  }
  return eligible.every((widget) => widget.groupId === first.groupId)
    ? first.groupId
    : null;
};
